export const tableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Sector IAF',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}